<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('special_cleaning')">
            <app-default-button
                :title="$fieldTitle('add', 'special_cleaning', true)"
                v-if="$can('create_hotel_special_cleaning')"
                @click="openModal()"
            />
        </app-page-top-section>

        <app-table
            id="hotel-special-cleaning-table"
            :options="options"
            @action="triggerActions"
        />

        <app-hotel-special-cleaning-create
            v-if="isModalActive"
            v-model="isModalActive"
            :selected-url="selectedUrl"
            @close="isModalActive = false"
        />

        <app-confirmation-modal
            v-if="confirmationModalActive"
            icon="trash-2"
            modal-id="app-confirmation-modal"
            @confirmed="confirmed('hotel-special-cleaning-table')"
            @cancelled="cancelled"
        />
    </div>
</template>

<script>
import HelperMixin from "../../../../../common/Mixin/Global/HelperMixin";
import HotelSpecialCleaningMixins from "../../../Mixins/HotelSpecialCleaningMixins";
import {TENANT_BASE_URL} from "../../../../../common/Config/UrlHelper";

export default {
    name  : "AppHotelSpecialCleaning",
    mixins: [HelperMixin, HotelSpecialCleaningMixins, TENANT_BASE_URL],
    data() {
        return {
            isModalActive: false,
            selectedUrl  : '',
        }
    },
    methods: {
        triggerActions(row, action, active) {
            if (action.title === this.$t('edit')) {
                this.selectedUrl   = `${TENANT_BASE_URL}app/hotel/special-cleaning/${row.id}`;
                this.isModalActive = true;
            } else {
                this.getAction(row, action, active)
            }
        },
        openModal() {
            this.isModalActive = true;
            this.selectedUrl   = ''
        },
    }
}
</script>